// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Highlights20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Highlights20: FC<Highlights20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="m17.02 14.896-2.25-2.25 1.063-1.063 2.25 2.25-1.062 1.063Zm-2.707-9L13.25 4.854l2.25-2.25 1.063 1.063-2.25 2.229Zm-8.542 0-2.25-2.25 1.062-1.063 2.25 2.25-1.062 1.063Zm-2.708 9L2 13.833l2.25-2.229 1.063 1.042-2.25 2.25Zm4.312-1.021 2.667-1.584 2.687 1.584-.708-3 2.312-1.98-3.062-.27-1.23-2.854-1.229 2.854-3.062.27 2.333 1.98-.708 3Zm-2.27 3.104 1.312-5.542-4.375-3.729 5.75-.5 2.25-5.229 2.25 5.25 5.75.48-4.375 3.728 1.312 5.542-4.937-2.938-4.938 2.938Z" />
        </svg>
    );
};

export default Highlights20;
